import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "space-between" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 판매 가능 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" (판매 제한 범위) ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" (전량 판매중) ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 약 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 주당 평균 구매 가격 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 추정 평가금액 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 원 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_toggle_icon = _resolveComponent("ag-toggle-icon")!

  return (_openBlock(), _createBlock(_component_ag_box, {
    "margin-top": "24px",
    width: "100%",
    "padding-bottom": "24px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_ag_box, {
            "margin-bottom": "16px",
            dp: "flex",
            "align-items": "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_box, {
                width: "24px",
                height: "24px",
                style: {"border-radius":"100%","position":"relative","flex-shrink":"0"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "img-circle img-responsive",
                    src: _ctx.stakeRef.partnershipLogo
                  }, null, 8, _hoisted_2),
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_ag_text, {
                dp: "inline-block",
                "margin-left": "8px",
                typography: "list16m"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.stakeRef.partnershipName) + " ", 1),
                  _withDirectives(_createElementVNode("span", null, _toDisplayString('(리드)'), 513), [
                    [_vShow, _ctx.checkIsLead]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_ag_toggle_icon, {
          name: "radio",
          value: _ctx.selectedIndexRef === _ctx.idxRef
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_ag_box, {
          dp: "flex",
          "justify-content": "space-between",
          "margin-left": "32px",
          "margin-bottom": "8px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_text, {
              color: "gray3",
              typography: "main14r"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createElementVNode("div", null, [
              (_ctx.checkIsLead && _ctx.stakeRef.asset <= '0')
                ? (_openBlock(), _createBlock(_component_ag_text, {
                    key: 0,
                    typography: "main14r"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }))
                : (_ctx.stakeRef.asset <= '0')
                  ? (_openBlock(), _createBlock(_component_ag_text, {
                      key: 1,
                      typography: "main14r"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_ag_text, {
                      key: 2,
                      typography: "main14r"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7,
                        _createVNode(_component_ag_text, { typography: "num14bk" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.stakeRef.qty)), 1)
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" 주 (" + _toDisplayString(_ctx.$filters.currency(_ctx.stakeRef.asset)) + " 좌) ", 1)
                      ]),
                      _: 1
                    }))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_ag_box, {
          "margin-left": "32px",
          dp: "flex",
          "justify-content": "space-between",
          "margin-bottom": "8px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_text, {
              color: "gray3",
              typography: "main14r"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createElementVNode("div", null, [
              _createVNode(_component_ag_text, { typography: "num14bk" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.stakeRef.price)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ag_text, { typography: "main14r" }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_ag_box, {
          dp: "flex",
          "margin-left": "32px",
          "justify-content": "space-between",
          "margin-bottom": "8px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_text, {
              color: 'gray3',
              typography: 'main14r'
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createElementVNode("div", null, [
              _createVNode(_component_ag_text, { typography: 'num14bk' }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.stakeRef.expectTotalPrice)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ag_text, { typography: 'main14r' }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}